import React, { useEffect, useState, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// import Sidenav from "../components/NavBars/Sidenav";
import ResponsiveAppBar from "../components/NavBars/ResNav";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


import {
  collection,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase";
import { AuthContext } from "../components/Auth/Auth";
import ClubHeader from "../../src/components/memberClubDetails/ClubHeader";
import ClubTabs from "../../src/components/memberClubDetails/ClubTabs";
import {
  // checkMembership,
  fetchClubById,
  // fetchClubs,
} from "../components/Helper";
import axios from "axios";
import { getUserByUid } from "../components/Helper";

// import { getToken } from "../components/Helper";

export default function MemberClubDetails() {
  const { clubId } = useParams();
  // const profile = localStorage.getItem("profile")
  //   ? JSON.parse(localStorage.getItem("profile"))?.response?.user
  //   : "";

  const { currentUser } = useContext(AuthContext);

  // const [currentUser, setCurrentUser] = useState(profile);
  const [clubData, setClubData] = useState(null);
  const [isMember, setIsMember] = useState(false);
  const [members, setMembers] = useState([]);
  const [memberIds, setMemberIds] = useState([]);
  const [membersData, setMembersData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const clubs = await fetchClubById(clubId);
      setClubData(clubs);
    }

    const checkMembership = async () => {
      if (currentUser) {
        const membershipsCollection = collection(db, "memberships");
        const membershipsQuery = query(
          membershipsCollection,
          where("user", "==", currentUser.uid),
          where("clubId", "==", clubId)
        );
        const membershipsSnapshot = await getDocs(membershipsQuery);
        setIsMember(!membershipsSnapshot.empty);
      }
    };

    const fetchMembers = async () => {
      const membershipsCollection = collection(db, "memberships");
      const membersQuery = query(
        membershipsCollection,
        where("clubId", "==", clubId)
      );
      const membersSnapshot = await getDocs(membersQuery);
      const memberIds = membersSnapshot.docs.map((doc) => doc.data().user);

      try {


        setMemberIds(memberIds);

        console.log("memberIds", memberIds);

        // const membersData = await Promise.all(
        //   memberIds.map(uid => getUserByUid(uid))
        // );
        // setMembersData(membersData);

        const membersData = await Promise.all(
          memberIds.map(uid => getDoc(doc(db, "users", uid)))
        );

        setMembersData(membersData.map(doc => doc.data()));


        // const user = getDoc(doc(db, "users", uid));



        console.log("membersData", membersData);
        
        console.log("all users", await getDocs(collection(db, "users")));

        // const responses = await getDocs(query(collection(db, "users"), where("uid", "in", memberEmails)));
        const responses = await getDocs(query(collection(db, "users")));
        console.log("responses members in club", responses.docs.map((doc) => doc.data()));



        setMembers(membersData);
        console.log("membersData:::", membersData);
      } catch (err) {
        console.error(err);
      } finally {
      }
    };

    fetchData();
    checkMembership();
    fetchMembers();
  }, [currentUser, clubId]);

  const handleJoinClub = async () => {
    console.log("${currentUser.uid}_${clubId}", `${currentUser.uid}_${clubId}`);
    if (currentUser && clubData) {
      const membershipRef = doc(
        db,
        "memberships",
        `${currentUser.uid}_${clubId}`
      );
      await setDoc(membershipRef, {
        user: currentUser.uid,
        clubId: clubId,
        dateJoined: Timestamp.fromDate(new Date()),
      });

      try {
        // const token = getToken();
        // console.log("token ", token);


        // const responses = await axios.get(
        //   `https://www.roundpier.com/api/user/view/${currentUser.uid}?token=${token}`
        // );

        const responses = await getDoc(doc(db, "users", currentUser.uid));
        console.log("responses-users", responses);

        let userData = responses.data();
        let mappedData = {
          name: userData.name,
          email: userData.email,
          // icon: userData.meta.og_image,
          // otherData: userData,
        };
        setIsMember(true);
        setMembers((prevMembers) => [...prevMembers, mappedData]);
      } catch (err) {
        console.error(err);
      } finally {
      }
    }
  };

  if (!clubData) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ py: 6, px: { xs: 2, md: 12, lg: 18, xl: 32 } }}>
      <Paper sx={{ padding: 3 }} elevation={0}>

      <> Total Members : {membersData.length} </>
      

        <ClubHeader
          clubData={clubData}
          currentUser={currentUser}
          isMember={isMember}
          handleJoinClub={handleJoinClub}
          clubId={clubId}
        />

        {isMember === true ? (
        <ClubTabs
          members={membersData}
          clubId={clubId}
          clubCategory={clubData?.category}
        />
        ) : null}
      </Paper>
    </Box>
  );
}
